import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CardlinkRedirectRequestDTO  {
    _originalTypeClassName = "ekylikeio.BO.CardlinkRedirectRequestDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CardlinkRedirectRequestDTO.translate = translateService;
}
this.mid = null;
this.orderid = null;
this.orderAmount = null;
this.status = null;
this.currency = null;
this.message = null;
this.riskScore = null;
this.txId = null;
this.paymentRef = null;
this.digest = null;
this.CardlinkRedirectRequestDTOKey = null;
this._key = this.CardlinkRedirectRequestDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
mid:any;
orderid:any;
orderAmount:any;
status:any;
currency:any;
message:any;
riskScore:any;
txId:any;
paymentRef:any;
digest:any;
private _CardlinkRedirectRequestDTOKey:any;
get CardlinkRedirectRequestDTOKey(): any {
    return this._CardlinkRedirectRequestDTOKey;
  }
set CardlinkRedirectRequestDTOKey(value: any) {
    this._CardlinkRedirectRequestDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CardlinkRedirectRequestDTOKey == null || $this.CardlinkRedirectRequestDTOKey == 0;
            }


}